import { Input, Select } from 'antd';
import type { DevicesState } from '../hooks/use-device-mapping-sheet';

interface DevicePickerProps {
  devices: DevicesState;
  value?: string;
  onChange?: (value: string) => void;
}

/** Pick from the vendor's own list where the adapter can give one; otherwise the id is typed. */
export function DevicePicker({ devices, value, onChange }: DevicePickerProps) {
  if (devices.status === 'loaded' && devices.result.supported) {
    return (
      <Select
        showSearch
        value={value}
        onChange={onChange}
        optionFilterProp="label"
        loading={false}
        placeholder="Select or search devices"
        options={devices.result.items.map((device) => ({ value: device.id, label: device.label ? `${device.label} (${device.id})` : device.id }))}
        notFoundContent="No devices found"
      />
    );
  }
  return <Input value={value} onChange={(event) => onChange?.(event.target.value)} placeholder="Type the device id" disabled={devices.status === 'loading'} />;
}
